'use client';
import Nav from '../../components/nav';
import Script from 'next/script';

export default function PrivacyPolicyPage() {
    return (
        <div>
            <Nav variant="light" />
            <div className="w-full pt-40 pb-24 mx-auto max-w-container">
                <div className="block mx-6 md:mx-0 md:grid md:grid-cols-14">
                    <div className="md:col-span-10 md:col-start-3">
                        <h1 className="mb-8 h1">Privacy Policy</h1>
                        <a
                            href="https://www.iubenda.com/privacy-policy/62323613"
                            className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iub-body-embed"
                            title="Privacy Policy"
                        >
                            https://www.iubenda.com/privacy-policy/62323613
                        </a>

                        <Script
                            id="iubenda-script-privacy"
                            src="https://cdn.iubenda.com/iubenda.js"
                            dangerouslySetInnerHTML={{
                                __html: `
                            (function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);
                        `,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
